// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3i8GN","column":"style_column__2MaDa"};